export default __webpack_public_path__ + "static/media/chords_fr.670567f6.png";